<template>
  <div class="w-100">
    <div class="my-3 alert alert-info text-center" role="alert">
      <h4>Aufgabenliste synchronisieren</h4>
      <p>
        Mit dieser Funktion können Sie die Aufgaben, welche den verschiedenen OP
        Nummern zugeordnet sind, aus Proffix laden. Die Synchronisation sollte
        immer dann angestossen werden, wenn in Proffix Anpassungen an den
        Operator Aktivitäten vorgenommen wurden.
      </p>
      <button @click="loadTasks" type="button" class="my-3 btn btn-primary">
        <i class="fas fa-sync"></i>&nbsp;Aufgabenliste synchronisieren
      </button>
    </div>
    <timeTrackingUsers
      :templateTibs="templateTibs"
      @error="error"
    ></timeTrackingUsers>
  </div>
</template>

<script>
import { loadTasks } from "@/common/timetrackingutils";
import timeTrackingUsers from "@/components/timetracking/TimeTrackingUsers.vue";

export default {
  name: "adminTimetracking",
  components: {
    timeTrackingUsers
  },
  data: function() {
    return {};
  },
  mounted() {},
  methods: {
    loadTasks() {
      loadTasks(
        this.propertiesTib,
        this.settingsTib,
        this.properties,
        this.settings
      );
    },
    error(msg) {
      this.$emit("error", msg);
    }
  },
  props: [
    "settings",
    "settingsTib",
    "properties",
    "propertiesTib",
    "templateTibs"
  ]
};
</script>
